import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import SearchContainer from '../search/SearchContainer';
import SearchToggle from '../search/SearchToggle';

const NavButtons = ({ currentUser, notificationCountFmt }) => {

  // DEFAULT DISPLAY NAME IS P FOR PROFILE AT THIS TIME
  let displayName = 'P';

  // @@TODO NOT SURE WHAT DISPLAY NAME KEY NAME IS COMING INTO FRONTEND
  if (currentUser?.displayName?.length) {
    // RESET DISPLAY NAME
    displayName = '';
    // SPLIT NAME
    const nameArray = currentUser?.displayName.toUpperCase().split(' ');
    // SELECT FIRST LETTERS AND APPEND TO DISPLAY NAME WHILE THE LENGTH OF IT IS LESS THAN 2
    for (let i = 0; i < nameArray?.length; i++) {
      const firstLetter = nameArray[i][0];
      if (displayName?.length < 2) displayName += firstLetter;
    }
  }


  return (
    <nav className="main-nav">
      <ul className="header-links">
        <SearchToggle />
        <li><NavLink className="nav-button create-btn" to="/create">+</NavLink></li>
        {/* @@TODO THIS NEEDS TO BE CONNECTED TO NOTIFICATIONS. JUST SAYS 10+ FOR STYLING PURPOSES FOR NOW */}
        <li><NavLink className="nav-button notification-btn" to="/inbox">{notificationCountFmt}</NavLink></li>
        <li><NavLink className="nav-button profile-btn" to={`/user/${currentUser.username}`}>
          <span>{displayName}</span>
        </NavLink></li>
       
      </ul>
      <SearchContainer />
    </nav>
  );
};

NavButtons.propTypes = {
  currentUser: PropTypes.shape({
    username: PropTypes.string,
  }).isRequired,
  notificationCountFmt: PropTypes.number
};

export default NavButtons;
